module.exports = __webpack_public_path__ + "584ccf7fb4b0326c58e155f82f1a5010.png";